import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <section className="flex items-center justify-center h-screen bg-gray-100 px-4">
            <div className="text-center max-w-xl">
                <motion.h1
                    initial={{ opacity: 0, y: -40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-7xl sm:text-9xl font-extrabold text-primary-800"
                >
                    404
                </motion.h1>

                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.5 }}
                    className="mt-4 text-2xl sm:text-3xl font-semibold text-gray-800"
                >
                    Page Not Found
                </motion.h2>

                <p className="mt-3 text-gray-600 text-base sm:text-lg">
                    The page you're looking for doesn't exist or has been moved.
                </p>

                <button
                    onClick={() => navigate("/")}
                    className="mt-6 inline-block px-6 py-3 rounded-lg bg-primary-800 text-white text-base font-medium hover:bg-primary-700 transition"
                >
                    Go to Home
                </button>
            </div>
        </section>
    );
}
